import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-inline-edit',
    templateUrl: './inline-edit.component.html',
    styleUrls: ['./inline-edit.component.scss'],
    standalone: false
})
export class InlineEditComponent implements OnInit {
  @Input() data: string;
  @Input() disabledFlag: boolean;
  @Input() defaultPlaceHolder: string;
  @Input() element: any; //AssessmentGoal, AssessmentObjective, AssessmentMeasure
  @Input() templateEdit: boolean;
  @Input() truncate: number = 100000;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();

  tempValue: any;

  editMode = false;
  constructor() {}

  ngOnInit() {
    if(!this.defaultPlaceHolder){
      this.defaultPlaceHolder = "Enter Text";
    }
  }

  onFocusOut() {
    if(!this.disabledFlag) {
      if (this.element) {
        this.element.isBeingEdited = false;
      }
      this.editMode = false;
      this.focusOut.emit(this.data);
    }
  }

  startEdit() {
    if(!this.disabledFlag) {
      if (this.element) {
        this.element.isBeingEdited = true;
      }
      this.tempValue = this.data;
    }
  }

  undo() {
    if(this.element){
      this.element.isBeingEdited = false;
    }
    this.editMode = false;
    this.data = this.tempValue;
    //todo make it undo the changes
  }

  enabledEditMode(){
    if(!this.disabledFlag) {
      this.editMode = true;
    }
  }

}
